<div
  class="app-loader egg-spinner"
  aria-label="Loading"
  aria-busy="true"
  role="status"
>
  <div>
    <div class="inner"></div>
  </div>
</div>
